import React, { createContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../config/firebaseApp';
import { SESSION_TIMEOUT_MS } from '../config/constants';

export const AuthContext = createContext({
  user: null,
  setUser: null,
  signOut: null
});

export const AuthProvider = ({ children }) => {
  const getFromStorage = () => {
    const user = auth.currentUser;
    const userFromStorage = localStorage.getItem('user');
    const lastActiveTime = localStorage.getItem('lastActiveTime');
    
    if (userFromStorage && lastActiveTime) {
      const now = new Date().getTime();
      const lastActive = parseInt(lastActiveTime);
      
      if (now - lastActive > SESSION_TIMEOUT_MS) {
        localStorage.removeItem('user');
        localStorage.removeItem('lastActiveTime');
        return null;
      }
      
      localStorage.setItem('lastActiveTime', now.toString());
      return JSON.parse(userFromStorage);
    }
    return user;
  };

  const [user, setUser] = useState(getFromStorage());
  
  useEffect(() => {
    const unregisterAuthObserver = onAuthStateChanged(auth, user => setUser(user));
    return () => unregisterAuthObserver();
  }, []);

  // 添加活動監聽器，自動更新最後活動時間
  useEffect(() => {
    if (user) {
      const updateLastActiveTime = () => {
        const now = new Date().getTime();
        localStorage.setItem('lastActiveTime', now.toString());
      };
      
      // 監聽各種用戶活動
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach(event => {
        document.addEventListener(event, updateLastActiveTime, true);
      });
      
      return () => {
        events.forEach(event => {
          document.removeEventListener(event, updateLastActiveTime, true);
        });
      };
    }
  }, [user]);

  const setToStorage = user => {
    setUser(user);
    const now = new Date().getTime();
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('lastActiveTime', now.toString());
  };

  const removeFromStorage = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('lastActiveTime');
    setUser(null);
  };

  const value = {
    user,
    setUser: setToStorage,
    signOut: removeFromStorage
  };

  // onAuthStateChanged(auth, user => {
  //   // console.log('🚀 ~ file: auth.jsx:55 ~ AuthProvider ~ user:', user);
  //   if (user) {
  //     // User is signed in, see docs for a list of available properties
  //     // https://firebase.google.com/docs/reference/js/firebase.User
  //     // const uid = user.uid;
  //     // ...
  //   } else {
  //     // User is signed out
  //     // ...
  //   }
  // });

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
